var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isPurchasePubliclyAvailable
    ? _c(
        "div",
        [
          _c(
            "cabinet-fl44-card-info-link",
            {
              attrs: {
                to: {
                  name: "purchases.grouped.item.view",
                  params: { group: "fl44", id: _vm.purchase.id },
                },
                icon: "search",
              },
            },
            [_vm._v("Информация о закупке")]
          ),
          _vm.purchase.flags.has_actual_proposals
            ? _c(
                "cabinet-fl44-card-info-link",
                {
                  attrs: {
                    to: {
                      name: "purchases.grouped.item.view",
                      params: { group: "fl44", id: _vm.purchase.id },
                      hash: "#atmo-proposals",
                    },
                    icon: "dynamic",
                  },
                },
                [_vm._v("Динамика предложений")]
              )
            : _vm._e(),
          _vm.purchase.flags.has_selected_supplier
            ? _c(
                "cabinet-fl44-card-info-link",
                {
                  attrs: {
                    to: {
                      name: "purchases.grouped.item.view",
                      params: { group: "fl44", id: _vm.purchase.id },
                      hash: "#atmo-supplier-info",
                    },
                    icon: "small_helmet",
                  },
                },
                [_vm._v("Итоговый протокол")]
              )
            : _vm._e(),
          _vm.purchase.flags.has_contract_info
            ? _c(
                "cabinet-fl44-card-info-link",
                {
                  attrs: {
                    to: {
                      name: "purchases.grouped.item.view",
                      params: { group: "fl44", id: _vm.purchase.id },
                      hash: "#atmo-contract",
                    },
                    icon: "grey_contract",
                  },
                },
                [_vm._v(" Контракт ")]
              )
            : _vm._e(),
          _vm.purchase.flags.has_contract_fulfillment_info
            ? _c(
                "cabinet-fl44-card-info-link",
                {
                  attrs: {
                    to: {
                      name: "purchases.grouped.item.view",
                      params: { group: "fl44", id: _vm.purchase.id },
                      hash: "#atmo-contract-fulfillment",
                    },
                    icon: "grey_file_small",
                  },
                },
                [_vm._v("Исполнение контракта")]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }